import Icon from "@ant-design/icons";

export const UserNotAssignable = (props: any) => {
  const userUnAssignableIcon = () => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
    d="M9.66602 24C9.66602 20.6337 12.3949 17.9048 15.7613 17.9048C19.1276 17.9048 21.8565 20.6337 21.8565 24H9.66602ZM16.5232 19.4918V22.4762H20.0726C19.5268 20.9322 18.1753 19.7689 16.5232 19.4918ZM14.9993 22.4762V19.4918C13.3473 19.7689 11.9957 20.9322 11.4499 22.4762H14.9993ZM15.7613 17.1429C13.2355 17.1429 11.1898 15.0971 11.1898 12.5714C11.1898 10.0457 13.2355 8 15.7613 8C18.287 8 20.3327 10.0457 20.3327 12.5714C20.3327 15.0971 18.287 17.1429 15.7613 17.1429ZM15.7613 15.619C17.4454 15.619 18.8089 14.2556 18.8089 12.5714C18.8089 10.8873 17.4454 9.52381 15.7613 9.52381C14.0771 9.52381 12.7136 10.8873 12.7136 12.5714C12.7136 14.2556 14.0771 15.619 15.7613 15.619Z"
    fill="#999999"
      />
    </svg>
  );
  return <Icon component={userUnAssignableIcon} {...props} />;
};
